import React, { useEffect, useRef, useState } from 'react';

const Quote = () => {
  const quoteRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (quoteRef.current) {
      observer.observe(quoteRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-20 bg-[#020617] border-y border-white/5 overflow-hidden" ref={quoteRef}>
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.8s ease-out forwards;
        }
      `}</style>
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 
          className="text-2xl md:text-4xl font-bold text-white mb-4 italic leading-snug animate-fade-in-up"
          style={isVisible ? { animationDelay: '0s' } : {}}
        >
          "End-to-end growth systems designed to scale{' '}
          <span className="text-[#007bff]">revenue</span> — not vanity metrics."
        </h2>
      </div>
    </section>
  );
};

export default Quote;
